import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for EMS | Neuro Wellness TMS Centers of America",
  description:
    "EMS professionals: learn about TMS therapy, SAINT TMS, and mental health treatment options for depression, anxiety, and PTSD in Coral Springs, FL.",
  canonical: "/tms-for-ems",
  keywords:
    "TMS for EMS, EMS depression treatment, EMT TMS therapy, EMS mental health Florida",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "TMS for Paramedics", href: "/tms-for-paramedics" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
];

export default function TmsForEms() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="EMS"
      title="TMS for EMS Professionals"
      subtitle="EMS workers face repeated trauma and high-stress calls. If medication hasn't helped, there are other treatment options."
    >
      <DecisionSection heading="What EMS professionals experience">
        <p>
          EMS professionals respond to people on the worst days of their lives.
          The repeated exposure to trauma, medical emergencies, and loss — often
          while managing your own adrenaline response — takes a cumulative toll.
          Depression, anxiety, and PTSD are common in EMS, and the irregular
          schedule makes it harder to access consistent care.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared for depression, non-invasive, outpatient",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression",
            "Prism for PTSD — EEG neurofeedback for PTSD symptoms",
            "IV ketamine and KAP",
            "Trauma-informed psychotherapy",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Confidentiality and insurance">
        <p>
          Your treatment is confidential. We do not contact your employer
          without your consent. Our team verifies your insurance benefits and
          handles authorization.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
